var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('v-container', [_c('div', {
    staticClass: "tit-wrap text-center"
  }, [_c('h2', {
    staticClass: "tit tit--lg"
  }, [_vm._v("Archives")])]), _c('router-view', _vm._b({
    attrs: {
      "name": "board",
      "code": "forms",
      "skin": "attachment",
      "hide-write-button": ""
    }
  }, 'router-view', {
    category: _vm.category
  }, false))], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }